import { render, staticRenderFns } from "./MyCredits.vue?vue&type=template&id=887f5aa0&scoped=true"
import script from "./MyCredits.vue?vue&type=script&lang=js"
export * from "./MyCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887f5aa0",
  null
  
)

export default component.exports